"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const provider_1 = require("../../../lib/constants/provider");
const messages_1 = __importDefault(require("../../../lib/messages"));
const PhoneNumberLink_1 = __importDefault(require("../../PhoneNumberLink/PhoneNumberLink"));
const NonBookableLocation_1 = __importDefault(require("../Locations/NonBookableLocation"));
const DropdownBookableLocation_1 = __importDefault(require("./DropdownBookableLocation"));
const LocationDropdownAddress_1 = __importDefault(require("./LocationDropdownAddress"));
const styles_1 = require("./styles");
/**
 * Component to render the location dropdown item inside Dropdown
 *
 * @param {object} param0 Input props for the component
 * @param {object} param0.location Location object
 * @param {boolean} param0.isSelected Flag to check if location is selected
 * @param {boolean} param0.isDisabled Flag to check if location is disabled
 * @param {Function} param0.onSelect Callback function to handle the selection of location
 *
 * @returns
 */
const LocationDropdownItem = ({ location, isSelected, isDisabled, onSelect }) => {
    const locationName = location.name ? location.name : location.street1;
    const locationAddress = (react_1.default.createElement(LocationDropdownAddress_1.default, { street1: location.street1, street2: location.street2, suite: location.suite, city: location.city, state: location.state, zip: location.zip }));
    if (location.type === provider_1.LOCATION_TYPES.BOOKABLE) {
        return (react_1.default.createElement(DropdownBookableLocation_1.default, Object.assign({}, location, { disabled: isDisabled, isSelected: isSelected, name: locationName, "data-testid": `loc-dropdown-item-${location.id}`, onSelect: onSelect }), locationAddress));
    }
    return (react_1.default.createElement(NonBookableLocation_1.default, Object.assign({}, location, { name: locationName, "data-testid": `loc-dropdown-item-${location.id}`, locationMessage: react_1.default.createElement(styles_1.StyledLocationMessage, { "data-testid": "LocationMessage" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.notBookableLocationMobile, { values: {
                    phone_number_link: (react_1.default.createElement("strong", null,
                        react_1.default.createElement(PhoneNumberLink_1.default, { phone: location.phone })))
                } }))) }), locationAddress));
};
LocationDropdownItem.propTypes = {
    location: prop_types_1.default.shape({
        id: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        name: prop_types_1.default.string,
        street1: prop_types_1.default.string,
        street2: prop_types_1.default.string,
        suite: prop_types_1.default.string,
        city: prop_types_1.default.string,
        state: prop_types_1.default.string,
        zip: prop_types_1.default.string,
        type: prop_types_1.default.oneOf([
            provider_1.LOCATION_TYPES.BOOKABLE,
            provider_1.LOCATION_TYPES.NON_BOOKABLE
        ]),
        phone: prop_types_1.default.string
    }).isRequired,
    isSelected: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    onSelect: prop_types_1.default.func
};
exports.default = LocationDropdownItem;
//# sourceMappingURL=LocationDropdownItem.js.map